import {ChangeDetectionStrategy,Component,inject,signal} from '@angular/core';
import {ServerError,ServerResponse} from '../../shared/server-message';
import {MATERIAL_IMPORTS} from '../../shared/material-imports';
import {COMMON_IMPORTS} from '../../shared/common-imports';
import {PopupComponent} from '../../misc/components/popup/popup';
import {AuthenticationService} from '../authentication.service';
import {FormBuilder,FormControl,Validators} from '@angular/forms';
import {InputEmptyToNullDirective} from '../../misc/directives/input-empty-to-null/input-empty-to-null.directive';
import {FormMessageComponent} from '../../misc/components/form-message/form-message';
import {environment} from '../../../environments/environment';

@Component({
	selector:'app-forgot-password-popup',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS,
		InputEmptyToNullDirective,
		FormMessageComponent
	],
	templateUrl:'./forgot-password-popup.html',
	styleUrl:'./forgot-password-popup.scss'
})
export class ForgotPasswordPopupComponent extends PopupComponent{
	private authenticationService=inject(AuthenticationService);
	private formBuilder=inject(FormBuilder);
	form=this.formBuilder.group({
		email:new FormControl<string|null>(null,{validators:[Validators.required,Validators.email]})
	});
	serverError=signal<ServerError|null>(null);
	serverResponse=signal<ServerResponse|null>(null);
	submitButtonActive=signal<boolean>(true);
	protected readonly environment=environment;
	
	
	passwordResetToken():void{
		if(this.submitButtonActive()){
			const {email}=this.form.getRawValue();
			if(!this.form.valid || !email){
				this.form.markAllAsTouched();
			}else{
				this.submitButtonActive.set(false);
				this.serverError.set(null);
				this.serverResponse.set(null);
				this.authenticationService.passwordResetToken({email})
				.subscribe({
					next:()=>{
						this.submitButtonActive.set(true);
						// The api answers the same whether or not the email has an account.
						this.serverResponse.set($localize`:@@forgot-password-popup-sent|Password reset requested message:Si ese email tiene una cuenta, te enviamos un enlace para restablecer la contraseña.`);
					},
					error:(error:ServerError)=>{
						this.submitButtonActive.set(true);
						this.serverError.set(error);
					}
				});
			}
		}
	}
	
}
